import {
  PURCHASE_ORDER_LIST_IPB,
  PURCHASE_ORDER_LIST_IPB_ERROR,
  CLEAN_PURCHASE_ORDER_LIST_IPB,
  CLEAN_PURCHASE_ORDER_LIST_IPB_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function purchaseOrderListIpbReducer(state = initialState, action) {
  switch (action.type) {
    case PURCHASE_ORDER_LIST_IPB:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case PURCHASE_ORDER_LIST_IPB_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_PURCHASE_ORDER_LIST_IPB:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_PURCHASE_ORDER_LIST_IPB_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
